module.exports = __webpack_public_path__ + "img/114.b51252a7.jpg";